import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type { IBrandComparisonApiResponse } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/brand-comparison/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useBrandComparisonData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<IBrandComparisonApiResponse> =>
    useLLMReportQuery<IBrandComparisonApiResponse, ILLMWidgetRequestParams>(
        "brandComparisonTable",
        apiClient.AiTracker.aiTrackerReportsSentimentAnalysisBrandComparisonList,
        params,
        options,
    );
